// Drawing a stored waveform (shared/audio/waveform.ts) as a row of bars.

import { decodeWaveform } from "@shared/audio/waveform.js";

/** Bar heights (0–1) for `count` bars: the loudest peak each bar covers, with
 * a floor so silence still draws a line. A missing or malformed waveform is a
 * flat placeholder — the card still has something to click. */
export function waveformBars(waveform: string | null | undefined, count: number, floor = 0.06): number[] {
  const peaks = decodeWaveform(waveform);
  if (!peaks) return Array.from({ length: count }, () => 0.18);
  const out: number[] = [];
  for (let i = 0; i < count; i++) {
    const from = Math.floor((i * peaks.length) / count);
    const to = Math.max(from + 1, Math.floor(((i + 1) * peaks.length) / count));
    let peak = 0;
    for (let j = from; j < to; j++) peak = Math.max(peak, peaks[j]!);
    out.push(Math.max(floor, peak / 255));
  }
  return out;
}
